import { getDiemDanhThuBay, updateDiemDanhThuBay } from '@/services/DiemDanhThuBay/diemdanhthubay';
import { useState } from 'react';
import type { DiemDanhThuBay } from '@/services/DiemDanhThuBay';

export default () => {
  const [danhSach, setDanhSach] = useState<DiemDanhThuBay.Record[]>([]);
  const [record, setRecord] = useState<DiemDanhThuBay.Record>();
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const getDiemDanhThuBayModel = async (
    donViId?: string,
    ngay?: number,
    thang?: number,
    nam?: number,
  ) => {
    setLoading(true);
    const response = await getDiemDanhThuBay({ page, limit, cond, donViId, ngay, thang, nam });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };

  const updateDiemDanhThuBayModel = async (id: string, data: any) => {
    setLoading(true);
    const response = await updateDiemDanhThuBay({ id, data });
    if (response) {
    }
    setLoading(false);
  };

  return {
    danhSach,
    loading,
    setLoading,
    getDiemDanhThuBayModel,
    updateDiemDanhThuBayModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setRecord,
    record
  };
};